import { ModelDefinition, Workflow, WorkflowType } from "@/generated";
import { Edge } from "@xyflow/react";
import { Connector } from "@/generated";
import { GoogleSheetsMapping } from "@/components/Integrations/GoogleDrivePicker";
import apiClient from "../api-client";
import { NoxusReactflowNode } from "@/types/spotflow";

export interface ParsedWorkflow extends Workflow {
  parsedDefinition: { nodes: NoxusReactflowNode[]; edges: Edge[] };
}

interface CustomNodeConfig {
  node_config: Record<string, any>;
  subflow_config?: {
    workflow_id: string;
    workflow_name: string;
    workflow_nodes: string[];
  };
  connector_config: {
    inputs: Connector[];
    outputs: Connector[];
  };
  display: {
    position: {
      x: number;
      y: number;
    };
    size: {
      width: number;
      height: number;
    };
  };
  id: string;
  type: string;
  name: string;
  plugin_name?: string;
}

interface CustomEdgeConfig {
  id: string;
  from_id: {
    connector_name: string;
    node_id: string;
    key?: string;
  };
  to_id: {
    connector_name: string;
    node_id: string;
    key?: string;
  };
}
export interface CustomFlowDefinition {
  nodes: CustomNodeConfig[];
  edges: CustomEdgeConfig[];
}

interface CustomCreateWorkflowRequest {
  name: string;
  type: WorkflowType;
  definition: CustomFlowDefinition;
}

interface RemoteNodeDefinition {
  inputs: any[];
  outputs: any[];
  config: Record<string, any>;
  type: string;
}

const getModels = (
  endpoint?: string,
  groupId?: string
): Promise<ModelDefinition[]> => {
  let path = endpoint || "/models/llms";
  if (groupId && !path.includes("/groups/")) {
    path = `/groups/${groupId}${path}`;
  }
  return new Promise((resolve, reject) => {
    apiClient
      .get(`/api/backend${path}`)
      .then((response) => resolve(response.data))
      .catch(reject);
  });
};

export const SpotflowService = {
  getModels,
};
